let USE_FIREBASE = false;
let JWT_SEC = process.env.JWT_SEC ? process.env.JWT_SEC : "sanarea";

let MENUS = [
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'dash'
  },
  {
    name: 'USER ',
    title: '사용자',
    icon: 'perm_identity',
    component: 'list',
    params: {
      objNm: 'User'
    }
  },
  {
    name: 'SCOPE ',
    title: '이안스코프',
    icon: "mdi-cellphone",
    component: 'list',
    params: {
      objNm: 'Device'
    }
  },

  {
    name: 'cust ',
    title: '고객',
    component: 'list',
    icon: "mdi-account-heart-outline",
    params: {
      objNm: 'Customer'
    }
  }, {
    name: 'client ',
    title: '병원',
    component: 'list',
    icon: "mdi-tooth",
    params: {
      objNm: 'Client'
    }
  },
  // {
  //   name: '단말소유자',
  //   title: '단말소유자',
  //   icon: "mdi:monitor-dashboard",
  //   component: 'list',
  //   params: {
  //     objNm: 'DeviceOwner'
  //   }
  // },
  {
    name: 'Image',
    title: '사진',
    component: 'list',
    icon: "mdi-file-cloud",
    params: {
      objNm: 'Image'
    }
  },
  {
    name: 'Videos',
    title: 'Videos',
    component: 'video',
    icon: 'live_tv',
    params: {
      objNm: 'Video'
    }
  },
  {
    name: 'Debug',
    title: '단말장비 DEBUG',
    icon: "mdi-cellphone-link",
    component: 'list',
    params: {
      objNm: 'Debug'
    }
  },
  {
    title: 'System',
    group: 'system',
    icon: 'mdi-cogs',
    name: 'System',
    items: [{
      name: 'Token',
      title: 'CertKey',
      component: 'list',
      params: {
        objNm: 'CertKey'
      }
    },
    {
      name: 'Token',
      title: 'Token',
      component: 'list',
      params: {
        objNm: 'Token'
      }
    }
    ]
  }, {
    title: 'Test',
    group: 'test',
    icon: 'mdi-tent',
    name: 'System',
    items: [{
      name: 'Test',
      title: 'Test',
      component: 'test',
      params: {
        objNm: 'User'
      }
    }
    ]
  }
]

export default {
  USE_FIREBASE,
  JWT_SEC,
  MENUS
}



// WEBPACK FOOTER //
// ./src/config.js